const onCompanyViewPageMatch = async (pathname, regex) => {
  const companyIdMatch = pathname.match(/\/view-company\/(\d+)/)
  const companyId = companyIdMatch ? companyIdMatch[1] : null
  const previousCompanyId = window.__impowerxCompanyViewCompanyId
  window.__impowerxCompanyViewCompanyId = companyId

  if (!companyId) {
    return
  }

  const tearDownCompanyViewKontaktierenVia = () => {
    document.querySelectorAll('[data-lux-kontaktieren-via="view-value"]').forEach((el) => el.remove())
    document.querySelectorAll('[data-lux-kontaktieren-via="view-impower-hidden"]').forEach((el) => {
      el.removeAttribute('data-lux-kontaktieren-via')
    })
    document.querySelectorAll('[data-impowerx-view-contact-roles="true"]').forEach((el) => el.remove())
    if (window.__luxKontaktierenViaViewApplied) {
      delete window.__luxKontaktierenViaViewApplied[companyId]
    }
    if (window.__luxKontaktierenViaViewPending) {
      delete window.__luxKontaktierenViaViewPending[companyId]
    }
  }

  // Switching companies in the SPA: drop previous Lux Kontaktieren-via UI/cache
  if (previousCompanyId && String(previousCompanyId) !== String(companyId)) {
    document.querySelectorAll('[data-lux-kontaktieren-via="view-value"]').forEach((el) => el.remove())
    document.querySelectorAll('[data-lux-kontaktieren-via="view-impower-hidden"]').forEach((el) => {
      el.removeAttribute('data-lux-kontaktieren-via')
    })
    if (window.__luxKontaktierenViaViewPending) {
      delete window.__luxKontaktierenViaViewPending[previousCompanyId]
    }
    if (window.__luxKontaktierenViaViewFetchGen) {
      window.__luxKontaktierenViaViewFetchGen.value += 1
    }
  }

  // After edit Speichern → view-company without remount: refetch Lux prefs
  if (String(window.__impowerxCompanyViewNeedsRefresh || '') === String(companyId)) {
    window.__impowerxCompanyViewNeedsRefresh = null
    tearDownCompanyViewKontaktierenVia()
  }

  const injectCompanyPartyNumbers = async () => {
    const dataCard = document.querySelector('.ant-card.data-card')
    if (!dataCard) {
      return false
    }

    let container = document.querySelector('.impowerx-data-injected-container')
    const contactIdFromContainer = container?.getAttribute('impowerx-data-contact-id')
    const contactID = window.__impowerxCompanyViewCompanyId

    if (contactIdFromContainer !== undefined && contactIdFromContainer !== contactID) {
      // Contact ID has changed, reload the page
      // this is to prevent data leak from previous contact
      window.location.reload()
    }

    // Wait for Notiz (same as person view) so we don't insert early and block later retries
    const labels = dataCard.querySelectorAll('.label')
    let notizLabel = null
    labels.forEach((label) => {
      if (label.textContent.trim() === 'Notiz') {
        notizLabel = label
      }
    })

    if (!notizLabel) {
      return false
    }

    const notizValue = notizLabel.nextElementSibling
    if (!notizValue) {
      return false
    }

    const attributes = ['debitorennummer', 'kreditorennummer']

    if (container) {
      return false
    }
    container = document.createElement('div')
    container.className = 'impowerx-data-injected-container'
    container.setAttribute('impowerx-data-contact-id', contactID)
    notizValue.insertAdjacentElement('afterend', container)

    const authToken = JSON.parse(localStorage.getItem('auth') || '{}')?.token
    const valuesFromImpowerX = await fetch(
      `${baseApiUrl}/api/impowerX/contacts/${contactID}?attributes=${attributes.join(',')}`,
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const valuesFromImpowerXData = await valuesFromImpowerX.json()
    const attributesData = valuesFromImpowerXData?.attributes

    attributes.forEach((attribute) => {
      const attributeData = attributesData?.find((item) => item.fieldName === attribute)
      const fieldLabel = document.createElement('div')
      fieldLabel.className = 'label'
      fieldLabel.textContent = attribute

      const fieldValue = document.createElement('div')
      fieldValue.className = 'value'
      // Use contactID from window (not closed-over companyId) so SPA navigations show the current contact
      fieldValue.textContent = attributeData?.value || contactID
      fieldValue.setAttribute('impowerx-data-injected', attribute)

      container.appendChild(fieldLabel)
      container.appendChild(fieldValue)
    })
    return true
  }

  await injectCompanyPartyNumbers()
  initContactRolesViewSection()
  initKontaktierenViaDispatchPreferences({
    mode: 'view',
    getContactId: () => window.__impowerxCompanyViewCompanyId || null,
  })

  const observer = new MutationObserver(async () => {
    await injectCompanyPartyNumbers()
    initContactRolesViewSection()
    initKontaktierenViaDispatchPreferences({
      mode: 'view',
      getContactId: () => window.__impowerxCompanyViewCompanyId || null,
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
